import React, { FC, useEffect } from "react";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import GuestySearchComponent from "components/SectionHeroArchivePage/GuestySearchComponent";
import SectionGridFilterCard from "./ListingsGridFilterCard";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useGetListings } from "hooks/useGetListings";

export interface ListingPagePageProps {
  className?: string;
}


const ListingPage: FC<ListingPagePageProps> = ({ className = "" }) => {

  const { t } = useTranslation();

  const { listings, handleSearch, listingsLoading, listingsError: error, handlePageChange, totalListingFound } = useGetListings();

  const noListingsFound = (!listingsLoading && totalListingFound === 0);
  if (error) return <div className="error">Error: {error.message}</div>;

  return (
    <div className={`nc-ListingStayPage relative overflow-hidden ${className}`} data-nc-id="ListingStayPage">
      <Helmet>
        <title>Booking</title>
      </Helmet>

      <BgGlassmorphism />
      <div className="container relative overflow-hidden">
        <GuestySearchComponent
          className="hidden sm:block pt-10 pb-24 lg:pb-28 lg:pt-16"
          onSearch={handleSearch}
        />

        {noListingsFound ? (
          <div className="h-[600px] flex items-start justify-center pt-10">
            <div className="text-center mb-10 p-6 bg-gray-100 rounded-lg shadow-lg">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">{t("No Results Found")}</h2>
              <p className="text-gray-600">
                {t(
                  "Sorry, we couldn't find any listings that match your search criteria. It is also possible that we are fully booked for the selected dates. Please try adjusting your filters or search terms."
                )}
              </p>
            </div>
          </div>
        ) : (
          <SectionGridFilterCard
            loading={listingsLoading}
            className="pb-24 lg:pb-28"
            listings={listings || []}
            handlePageChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
};

export default ListingPage;